export const WHATSAPP_NUMBER = "917979810342";
export const PHONE_DISPLAY = "7979810342";
export const EMAIL = "modi.harshita006@gmail.com";
export const MAPS_URL = "https://goo.gl/maps/AbCmjsrm3gZde1fs5";
export const INSTAGRAM_URL =
  "https://www.instagram.com/harshizkitchen2025?stkn=MW02cHh0dTZubGpiYw==";
export const FACEBOOK_URL = "https://www.facebook.com/share/1F1wVUhLJ9/";
export const HOURS = "Every day, 9:00 AM to 6:00 PM";

const u = (base, w) => `${base}&w=${w}&q=70&auto=format`;

export const IMAGES = {
  hero: u(
    "https://images.unsplash.com/reserve/EnF7DhHROS8OMEp2pCkx_Dufer%20food%20overhead%20hig%20res.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxib3RhbmljYWwlMjBraXRjaGVuJTIwZm9vZCUyMG92ZXJoZWFkfGVufDB8fHx8MTc5MTk4MzkxM3ww&ixlib=rb-4.1.0",
    1400
  ),
  thali: u(
    "https://images.unsplash.com/photo-1546833999-b9f581a1996d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw3fHxpbmRpYW4lMjBwYXJhdGhhJTIwdGhhbGklMjBjdXJyeXxlbnwwfHx8fDE3OTE5ODM5MTN8MA&ixlib=rb-4.1.0",
    900
  ),
  paratha: u(
    "https://images.unsplash.com/photo-1559561724-732dbca7be1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBwYXJhdGhhJTIwdGhhbGklMjBjdXJyeXxlbnwwfHx8fDE3OTE5ODM5MTN8MA&ixlib=rb-4.1.0",
    600
  ),
  curry: u(
    "https://images.unsplash.com/photo-1680359873864-43e89bf248ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBwYXJhdGhhJTIwdGhhbGklMjBjdXJyeXxlbnwwfHx8fDE3OTE5ODM5MTN8MA&ixlib=rb-4.1.0",
    600
  ),
  samosa: u(
    "https://images.unsplash.com/photo-1601050690597-df0568f70950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBkcnklMjBzbmFja3MlMjBuYW1rZWVuJTIwc2Ftb3NhfGVufDB8fHx8MTc5MTk4MzkxM3ww&ixlib=rb-4.1.0",
    600
  ),
  namkeen: u(
    "https://images.unsplash.com/photo-1601050690117-94f5f6fa8bd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBkcnklMjBzbmFja3MlMjBuYW1rZWVuJTIwc2Ftb3NhfGVufDB8fHx8MTc5MTk4MzkxM3ww&ixlib=rb-4.1.0",
    600
  ),
};

export const WEIGHTS = [
  { label: "250 g", factor: 0.25 },
  { label: "500 g", factor: 0.5 },
  { label: "1 kg", factor: 1 },
];

export const inr = (n) =>
  "₹" +
  (Number.isInteger(n)
    ? n.toLocaleString("en-IN")
    : n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export const SECTIONS = [
  {
    id: "breakfast",
    pill: "Breakfast",
    title: "Breakfast",
    subtitle: "Fresh morning classics, made every day",
    img: IMAGES.samosa,
  },
  {
    id: "lunch",
    pill: "Lunch & Dinner",
    title: "Lunch & Dinner",
    subtitle: "Wholesome homemade meals",
    groups: [
      { id: "roti", title: "Roti & Indian Breads", img: IMAGES.paratha },
      { id: "veg", title: "Vegetables & Curries", img: IMAGES.curry },
      { id: "rice", title: "Rice & Meals", img: IMAGES.thali },
    ],
  },
  { id: "combo", pill: "Lunch Combo", title: "Lunch Combo", subtitle: "One complete wholesome thali", img: IMAGES.thali },
  { id: "party", pill: "Party Snacks", title: "Party Snacks", subtitle: "Crowd-pleasers for every celebration", img: IMAGES.hero },
  { id: "dry", pill: "Dry Snacks", title: "Dry Snacks", subtitle: "Traditional namkeen, priced per kg", img: IMAGES.namkeen },
];

// type: piece | plate | pack | unit | kg | enquiry | combo
export const ITEMS = [
  // BREAKFAST
  { id: "poha", name: "Poha", price: 60, type: "plate", section: "breakfast" },
  { id: "uttapam", name: "Uttapam", price: 140, type: "pack", packSize: 2, section: "breakfast" },
  { id: "idli-sambar-chutney", name: "Idli Sambar Chutney", price: 150, type: "pack", packSize: 4, section: "breakfast" },
  { id: "vegetable-cutlet", name: "Vegetable Cutlet", price: 20, type: "piece", section: "breakfast" },
  { id: "samosa", name: "Samosa", price: 15, type: "piece", section: "breakfast" },
  { id: "khandvi", name: "Khandvi", price: 350, type: "kg", section: "breakfast" },
  { id: "dhokla", name: "Dhokla", price: 15, type: "piece", section: "breakfast" },
  { id: "pav-bhaji", name: "Pav Bhaji", price: 160, type: "unit", unitLabel: "2 pav + bhaji", section: "breakfast" },
  { id: "kachori-sabzi", name: "Kachori Sabzi", price: 150, type: "unit", unitLabel: "6 pcs + sabzi", section: "breakfast" },
  { id: "sattu-paratha", name: "Sattu Paratha", price: 120, type: "pack", packSize: 2, section: "breakfast" },
  { id: "paneer-paratha", name: "Paneer Paratha", price: 140, type: "pack", packSize: 2, section: "breakfast" },
  { id: "vegetable-paratha", name: "Vegetable Paratha", price: 140, type: "pack", packSize: 2, section: "breakfast" },
  { id: "onion-paratha", name: "Onion Paratha", price: 140, type: "pack", packSize: 2, section: "breakfast" },
  { id: "aloo-paratha", name: "Aloo Paratha", price: 120, type: "pack", packSize: 2, section: "breakfast" },
  { id: "thepla-pickle", name: "Thepla with Pickle", price: 70, type: "pack", packSize: 5, section: "breakfast" },
  { id: "vegetable-sandwich", name: "Vegetable Sandwich", price: 50, type: "unit", unitLabel: "1 sandwich", section: "breakfast" },
  { id: "grill-sandwich", name: "Grill Sandwich", price: 70, type: "unit", unitLabel: "1 sandwich", section: "breakfast" },
  { id: "cheese-grill-sandwich", name: "Cheese Grill Sandwich", price: 90, type: "unit", unitLabel: "1 sandwich", section: "breakfast" },
  { id: "chola-bhatura", name: "Chola Bhatura", price: 150, type: "pack", packSize: 2, section: "breakfast" },
  { id: "chola-kulcha", name: "Chola Kulcha", price: 150, type: "pack", packSize: 2, section: "breakfast" },
  { id: "kanji-vada", name: "Kanji Vada", price: 15, type: "piece", section: "breakfast" },
  { id: "dahi-vada", name: "Dahi Vada", price: 30, type: "piece", section: "breakfast" },
  { id: "vada-pav", name: "Vada Pav", price: 20, type: "piece", section: "breakfast" },
  // ROTI
  { id: "phulka", name: "Phulka", price: 10, type: "piece", section: "roti" },
  { id: "paratha", name: "Paratha", price: 20, type: "piece", section: "roti" },
  { id: "stuffed-kulcha", name: "Stuffed Kulcha", price: 40, type: "piece", section: "roti" },
  { id: "laccha-paratha", name: "Laccha Paratha", price: 30, type: "piece", section: "roti" },
  { id: "missi-roti", name: "Missi Roti", price: 30, type: "piece", section: "roti" },
  { id: "masala-paratha", name: "Masala Paratha", price: 30, type: "piece", section: "roti" },
  // VEGETABLES
  { id: "aloo-matar", name: "Aloo Matar", price: 120, type: "plate", section: "veg" },
  { id: "paneer-butter-masala", name: "Paneer Butter Masala", price: 180, type: "plate", section: "veg" },
  { id: "paneer-matar", name: "Paneer Matar", price: 180, type: "plate", section: "veg" },
  { id: "gatta", name: "Gatta", price: 129, type: "plate", section: "veg" },
  { id: "mix-veg", name: "Mix Veg", price: 180, type: "plate", section: "veg" },
  { id: "gobhi-matar", name: "Gobhi Matar", price: 140, type: "plate", section: "veg" },
  { id: "bhindi-bharma", name: "Bhindi Bharma", price: 130, type: "plate", section: "veg" },
  { id: "parwal-bharma", name: "Parwal Bharma", price: 130, type: "plate", section: "veg" },
  { id: "stuffed-tamato", name: "Stuffed Tamato", price: 120, type: "plate", section: "veg" },
  { id: "stuffed-aloo", name: "Stuffed Aloo", price: 120, type: "plate", section: "veg" },
  { id: "aloo-pyaz-sabzi", name: "Aloo Pyaz Sabzi", price: 120, type: "plate", section: "veg" },
  { id: "aloo-bhujia", name: "Aloo Bhujia", price: 100, type: "plate", section: "veg" },
  // RICE & MEALS
  { id: "jeera-rice", name: "Jeera Rice", price: 100, type: "plate", section: "rice" },
  { id: "vegetable-pulao", name: "Vegetable Pulao", price: 140, type: "plate", section: "rice" },
  { id: "onion-peas-pulao", name: "Onion & Peas Pulao", price: 120, type: "plate", section: "rice" },
  { id: "burrito-bowl", name: "Burrito Bowl", price: 240, type: "plate", section: "rice" },
  { id: "curry-rice", name: "Curry Rice", price: 130, type: "plate", section: "rice" },
  { id: "dal-chawal-aloo-bhujia", name: "Dal Chawal Aloo Bhujia", price: 150, type: "plate", section: "rice" },
  { id: "rajma-chawal", name: "Rajma Chawal", price: 150, type: "plate", section: "rice" },
  { id: "chola-chawal", name: "Chola Chawal", price: 150, type: "plate", section: "rice" },
  { id: "sambar-chawal", name: "Sambar Chawal", price: 130, type: "plate", section: "rice" },
  { id: "dal-baati-bharta", name: "Dal Baati Bharta", price: 150, type: "unit", unitLabel: "4 pcs + bharta", section: "rice" },
  // LUNCH COMBO
  {
    id: "lunch-combo",
    name: "Harshi's Lunch Combo",
    price: 350,
    type: "combo",
    unitLabel: "per combo",
    section: "combo",
    includes: ["4 Roti", "Rice", "Sabzi", "Dal / Curry", "Salad", "Pickle", "Papad"],
  },
  // PARTY SNACKS
  { id: "cheese-balls", name: "Cheese Balls", type: "enquiry", section: "party", note: "Price on enquiry" },
  { id: "paneer-chilli", name: "Paneer Chilli", price: 300, type: "pack", packSize: 8, section: "party" },
  { id: "noodles", name: "Noodles", price: 150, type: "plate", section: "party" },
  { id: "white-sauce-pasta", name: "White Sauce Pasta", price: 200, type: "plate", section: "party" },
  { id: "pink-sauce-pasta", name: "Pink Sauce Pasta", price: 250, type: "plate", section: "party" },
  { id: "red-sauce-pasta", name: "Red Sauce Pasta", price: 200, type: "plate", section: "party" },
  { id: "fried-rice", name: "Fried Rice", price: 150, type: "plate", section: "party" },
  // DRY SNACKS
  { id: "suhali", name: "Suhali", price: 300, type: "kg", section: "dry" },
  { id: "nimki", name: "Nimki", price: 300, type: "kg", section: "dry" },
  { id: "thekua", name: "Thekua", price: 400, type: "kg", section: "dry" },
  { id: "beetroot-chips", name: "Beetroot Chips", price: 500, type: "kg", section: "dry" },
  { id: "ragi-chips", name: "Ragi Chips", price: 500, type: "kg", section: "dry" },
  { id: "banana-chips", name: "Banana Chips", price: 500, type: "kg", section: "dry" },
  { id: "broccoli-chips", name: "Broccoli Chips", price: 500, type: "kg", section: "dry" },
  { id: "jaw-chips", name: "Jaw Chips", price: 350, type: "kg", section: "dry" },
  { id: "mathi", name: "Mathi", price: 400, type: "kg", section: "dry" },
  { id: "dates-dry-fruit-ladoo", name: "Dates Dry Fruit Ladoo", price: 1300, type: "kg", section: "dry" },
  { id: "gond-ladoo", name: "Gond Ladoo", price: 1000, type: "kg", section: "dry" },
];

export const unitLabel = (item) => {
  switch (item.type) {
    case "piece":
      return "per piece";
    case "plate":
      return "per plate";
    case "pack":
      return `pack of ${item.packSize}`;
    case "kg":
      return "per kg";
    case "combo":
      return "per combo";
    default:
      return item.unitLabel || "";
  }
};

export const kgPrice = (item, factor) => item.price * factor;

const GENERATED_DISHES = new Set([
  "poha","uttapam","idli-sambar-chutney","vegetable-cutlet","samosa","khandvi","dhokla","pav-bhaji","kachori-sabzi","sattu-paratha","paneer-paratha","vegetable-paratha","onion-paratha","aloo-paratha","thepla-pickle","vegetable-sandwich","grill-sandwich","cheese-grill-sandwich","chola-bhatura","chola-kulcha","kanji-vada","dahi-vada","vada-pav",
  "phulka","paratha","stuffed-kulcha","laccha-paratha","missi-roti","masala-paratha",
  "aloo-matar","paneer-butter-masala","paneer-matar","gatta","mix-veg","gobhi-matar","bhindi-bharma","parwal-bharma","stuffed-tamato","stuffed-aloo","aloo-pyaz-sabzi","aloo-bhujia",
  "jeera-rice","vegetable-pulao","onion-peas-pulao","burrito-bowl","curry-rice","dal-chawal-aloo-bhujia","rajma-chawal","chola-chawal","sambar-chawal","dal-baati-bharta",
  "lunch-combo",
  "paneer-chilli","noodles","white-sauce-pasta","pink-sauce-pasta","red-sauce-pasta","fried-rice",
  "suhali","nimki","thekua","beetroot-chips","ragi-chips","banana-chips","broccoli-chips","jaw-chips","mathi","dates-dry-fruit-ladoo","gond-ladoo",
]);

export const dishImg = (item, fallback) =>
  GENERATED_DISHES.has(item.id) ? `/dishes/${item.id}.jpg` : fallback;
